import BaseAPI from "api/api"
import { PaymentInstallmentListProps } from "component/Treatments/PaymentInstallment/PaymentInstallment"

const path = 'installment'

export interface FindAllInstallment {
    page?: number
    pageLimit?: number
    sortType?: string
    sortBy?: string
    search?: string
    dateStart?: string
    dateEnd?: string
}

export interface FindByPatientInstallment {
    patientId: number
    page?: number
    pageLimit?: number
    sortType?: string
    sortBy?: string
    search?: string
    dateStart?: string
    dateEnd?: string
}

export interface CancelInstallment {
    // 
    username: string
    password: string
    cancelRemark?: string
}

export default class InstallmentApi extends BaseAPI {

    static findAll(props: FindAllInstallment): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
    }

    static findByPatient(props: FindByPatientInstallment): Promise<any> {
        return this.api.get(`${path}/patient/${props.patientId}`, { params: { ...props } })
    }

    static update(installmentPaymentId: number, payload: { installmentList: PaymentInstallmentListProps[] }): Promise<any> {
        return this.api.patch(`${path}/${installmentPaymentId}`, payload)
    }
    // ยกเลิกเเบ่งชำระ http://localhost:3800/api/installment/cancel/{installmentPaymentId}

    static cancel(installmentPaymentId: number, payload: CancelInstallment): Promise<any> {
        return this.api.patch(`${path}/cancel/${installmentPaymentId}`, payload)
    }

}